import { Link } from "react-router-dom";
import useScrollAnimation from "../../../hooks/useScrollAnimation";

const previews = [
  {
    industry: "MED SPA",
    metric: "+42%",
    label: "BOOKINGS INCREASE",
    detail: "Los Angeles, CA",
    result: "Full AI acquisition and follow-up system deployed in 14 days.",
    icon: "ri-sparkling-2-line",
  },
  {
    industry: "CLINICAL PRACTICE",
    metric: "3x",
    label: "FASTER RESPONSE",
    detail: "Chicago, IL",
    result: "Automated intake reduced staff workload by 67%.",
    icon: "ri-hospital-line",
  },
  {
    industry: "WELLNESS BRAND",
    metric: "+28%",
    label: "RETENTION RATE",
    detail: "Miami, FL",
    result: "Lifecycle system doubled repeat booking revenue.",
    icon: "ri-heart-pulse-line",
  },
];

const CaseStudiesPreview = () => {
  const sectionRef = useScrollAnimation<HTMLElement>();

  return (
    <section
      ref={sectionRef}
      className="bg-[#1A1A1A] py-24 md:py-36 px-6 md:px-16 relative overflow-hidden"
    >
      {/* Top-center glow */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 pointer-events-none"
        style={{
          width: 600,
          height: 2,
          background: "linear-gradient(90deg, transparent, rgba(255,209,0,0.3), transparent)",
        }}
      />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16 reveal">
          <span
            className="text-[#FFD100] text-xs tracking-[4px] font-bold block mb-4"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            PERFORMANCE DATA
          </span>
          <h2
            className="text-white font-black uppercase text-4xl md:text-5xl"
            style={{ fontFamily: "Arial, sans-serif", letterSpacing: "-0.5px" }}
          >
            PROVEN RESULTS
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {previews.map((p, i) => (
            <div
              key={i}
              className={`reveal delay-${(i + 1) * 100} group bg-black border-t-2 border-[#FFD100] p-8 flex flex-col gap-6 relative overflow-hidden transition-all duration-300 hover:bg-[#111]`}
            >
              {/* Ghost icon */}
              <div
                className="absolute bottom-4 right-4 opacity-[0.05] group-hover:opacity-[0.08] transition-opacity duration-300"
                style={{ fontSize: "6rem" }}
              >
                <i className={p.icon} style={{ color: "#FFD100" }} />
              </div>

              {/* Industry tag */}
              <div className="flex items-center justify-between">
                <span
                  className="text-[#FFD100] text-xs font-black tracking-[3px] border border-[#FFD100]/40 px-3 py-1"
                  style={{ fontFamily: "Arial, sans-serif" }}
                >
                  {p.industry}
                </span>
                <div className="w-6 h-6 flex items-center justify-center border border-[#FFD100]/20">
                  <i className={`${p.icon} text-[#FFD100]/40 text-xs`} />
                </div>
              </div>

              {/* Metric — dramatic */}
              <div>
                <div
                  className="count-up text-[#FFD100] font-black leading-none"
                  style={{
                    fontFamily: "Arial, sans-serif",
                    fontSize: "clamp(3.5rem, 7vw, 5rem)",
                    letterSpacing: "-2px",
                  }}
                >
                  {p.metric}
                </div>
                <div
                  className="text-white font-bold text-sm tracking-[1.5px] mt-2"
                  style={{ fontFamily: "Arial, sans-serif" }}
                >
                  {p.label}
                </div>
              </div>

              {/* Divider */}
              <div className="w-full h-px bg-gradient-to-r from-[#FFD100]/20 to-transparent" />

              {/* Detail */}
              <p
                className="text-[#E5E5E5] text-sm leading-relaxed flex-1"
                style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.75" }}
              >
                {p.result}
              </p>

              {/* Bottom */}
              <div className="border-t border-white/10 pt-4 flex items-center justify-between">
                <span
                  className="text-[#E5E5E5]/60 text-xs"
                  style={{ fontFamily: "Arial, sans-serif" }}
                >
                  {p.detail}
                </span>
                <Link
                  to="/case-studies"
                  className="text-[#FFD100] text-xs font-black tracking-[2px] flex items-center gap-1 group-hover:gap-2 transition-all duration-300 cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "Arial, sans-serif" }}
                >
                  VIEW <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* View All */}
        <div className="reveal delay-400 text-center mt-12">
          <Link
            to="/case-studies"
            className="border border-[#FFD100] text-[#FFD100] text-xs font-black tracking-[3px] px-10 py-4 cursor-pointer whitespace-nowrap hover:bg-[#FFD100] hover:text-black transition-all duration-300 inline-block"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            VIEW ALL CASE STUDIES
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesPreview;
